interface EnableMockingOptions {
  shouldRequestBeBypassed: (url: string, bypassList: string[]) => boolean;
  mockRequestsBypassList: string[];
}

async function enableMocking({
  shouldRequestBeBypassed,
  mockRequestsBypassList,
}: EnableMockingOptions) {
  const isProduction = import.meta.env.PROD;
  const isMockDataEnabled = import.meta.env.VITE_MOCK_DATA === 'true';

  if (isProduction || !isMockDataEnabled) {
    return;
  }

  const { worker } = await import('../../mocks/browser');
  await worker.start({
    onUnhandledRequest(request, print) {
      if (shouldRequestBeBypassed(request.url, mockRequestsBypassList)) {
        return;
      }
      print.warning();
    },
  });
}

export default enableMocking;
